import { render, staticRenderFns } from "./bd_perInfo.vue?vue&type=template&id=ccbd3a6a"
import script from "./bd_perInfo.vue?vue&type=script&lang=js"
export * from "./bd_perInfo.vue?vue&type=script&lang=js"
import style0 from "./bd_perInfo.vue?vue&type=style&index=0&id=ccbd3a6a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports